import React from 'react';
import { formatShortTimestamp, getValueStatus } from '../../utils';

/**
 * Individual room card component
 */
export const RoomCard = ({ room, onSelect, sensorConfig }) => {
  const isConnected = room.hasData;
  const isDemoCard = room.isDemoCard;
  const roomLabel = room.displayName || room.code;

  return (
    <div
      className={`room-card fade-in ${isConnected ? 'connected' : ''} ${isDemoCard ? 'demo' : ''}`}
      onClick={() => {
        if (!isDemoCard) onSelect(room.code);
      }}
    >
      <div className="room-card-header">
        <div className="room-icon">AQ</div>
        <div className={`room-status-badge ${isConnected ? 'connected' : 'disconnected'}`}>
          <div className="room-status-dot"></div>
          <span>{isConnected ? 'Conectado' : (isDemoCard ? 'Demo NOC' : 'Desconectado')}</span>
        </div>
      </div>

      <div className="room-name">{roomLabel}</div>
      <div className="room-code-hint">{room.zone} · {room.codeHint || room.code}</div>
      <div className="room-last-update">
        {isDemoCard ? 'Tarjeta de exhibicion NOC' : formatShortTimestamp(room.lastUpdate)}
      </div>

      {room.data && (
        <div className="room-metrics">
          <div className="room-metric">
            <div className={`room-metric-value ${getValueStatus(room.data.temp1, sensorConfig.temperature)}`}>{room.data.temp1?.toFixed(1)}{'\u00B0C'}</div>
            <div className="room-metric-label">Temp 1</div>
          </div>
          <div className="room-metric">
            <div className={`room-metric-value ${getValueStatus(room.data.temp2, sensorConfig.temperature)}`}>{room.data.temp2?.toFixed(1)}{'\u00B0C'}</div>
            <div className="room-metric-label">Temp 2</div>
          </div>
          <div className="room-metric">
            <div className={`room-metric-value ${getValueStatus(room.data.do1_mgL, sensorConfig.oxygen)}`}>{room.data.do1_mgL?.toFixed(2)}</div>
            <div className="room-metric-label">DO1 mg/L</div>
          </div>
          <div className="room-metric">
            <div className={`room-metric-value ${getValueStatus(room.data.do2_mgL, sensorConfig.oxygen)}`}>{room.data.do2_mgL?.toFixed(2)}</div>
            <div className="room-metric-label">DO2 mg/L</div>
          </div>
        </div>
      )}

      <button className="room-enter-btn" disabled={isDemoCard}>
        {isDemoCard ? 'Tarjeta Demo NOC' : 'Ver Dashboard'}
      </button>
    </div>
  );
};
